function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21 26C23.2091 26 25 24.2091 25 22C25 19.7909 23.2091 18 21 18C18.7909 18 17 19.7909 17 22C17 24.2091 18.7909 26 21 26Z",
  stroke: "#4A90E2",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33 25C34.6569 25 36 23.6569 36 22C36 20.3431 34.6569 19 33 19C31.3431 19 30 20.3431 30 22C30 23.6569 31.3431 25 33 25Z",
  stroke: "#4A90E2",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 32C14.6206 30.0496 17.7693 29 21 29C24.2307 29 27.3794 30.0496 30 32",
  stroke: "#4A90E2",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28 29C29.4559 28.3499 31.2052 28 33 28C34.7948 28 36.5441 28.3499 38 29",
  stroke: "#4A90E2",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var SvgCustomersNew = function SvgCustomersNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomersNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customers-new.4412cbd8.svg";
export { ForwardRef as ReactComponent };